/* Monsuri — custom GA4 event tracking (front-of-funnel engagement).
 *
 * Fills the gaps Elevar's ecommerce data layer does NOT cover: mega-nav
 * engagement, the Build-a-Gift-Set promo funnel, and gift-builder interactions.
 *
 * Delivery: the storefront loads GA4 DIRECTLY via gtag.js (id below) — the
 * GTM-TPTGMCR container is only present as a <noscript> fallback and its gtm.js
 * never executes, so a dataLayer.push alone would go nowhere. We therefore send
 * each event straight to the live GA4 tag with gtag('event', …, { send_to }).
 * (Verified live 2026-06-09: gtag events land in property 308962333 / Realtime.)
 * If gtag is ever absent but a GTM container is restored, we fall back to a
 * dataLayer.push so the event still routes — either/or, so it never double-fires.
 * See Documentation/GA4_MEASUREMENT_PLAN.md.
 *
 * It does NOT emit ecommerce events (view_item / add_to_cart / purchase) — Elevar
 * owns those; duplicating them would double-count. Pure additive engagement layer.
 */
(function () {
  'use strict';

  // Public GA4 measurement ID for monsuri.com (not a secret — exposed in page
  // source as gtag/js?id=G-04VG181C0C). Scopes our events to the right property.
  var GA4_MEASUREMENT_ID = 'G-04VG181C0C';

  function track(event, params) {
    try {
      if (typeof window.gtag === 'function') {
        var p = { send_to: GA4_MEASUREMENT_ID };
        if (params) {
          for (var k in params) {
            if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
          }
        }
        window.gtag('event', event, p);
        return;
      }
      // Fallback: no gtag on the page → push for a GTM container to consume.
      window.dataLayer = window.dataLayer || [];
      var payload = { event: event };
      if (params) {
        for (var j in params) {
          if (Object.prototype.hasOwnProperty.call(params, j)) payload[j] = params[j];
        }
      }
      window.dataLayer.push(payload);
    } catch (e) { /* never break the page for analytics */ }
  }

  function txt(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }
  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches);
  }
  function templateName() {
    return (window.Shopify && window.Shopify.template) || document.documentElement.getAttribute('data-template') || '';
  }

  // Capture phase so the event is pushed before any navigation/unload.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // 1) NAV engagement — any link inside the desktop/mobile nav (tier-1 + sub-links)
    var link = t.closest('a[href]');
    var navScope = link && link.closest('.main-nav, .nav-mobile, .nav-desktop, [data-meganav-desktop], [data-meganav-mobile]');
    if (link && navScope) {
      var handleEl = link.closest('[data-meganav-handle]');
      var isTier1 = link.classList.contains('nav-desktop__tier-1-link') || link.classList.contains('nav-mobile__tier-1-link');
      // v4 mega-menu context (ported from meganav.js bindAnalytics, which we remove to
      // avoid a duplicate click path): element type, panel layout, panel handle, position.
      var trackEl = link.closest('[data-mn-track]');
      var layoutEl = link.closest('[data-mn-layout]');
      var panelEl = link.closest('[data-meganav-handle]') || link.closest('[data-mn-panel-target]') || link.closest('[data-mn-tier1]');
      var navPos = 0;
      if (link.parentElement) {
        var sibs = link.parentElement.children;
        for (var si = 0; si < sibs.length; si++) { if (sibs[si] === link) { navPos = si + 1; break; } }
      }
      track('mega_nav_click', {
        nav_item: txt(link) || link.getAttribute('aria-label') || '',
        nav_url: link.getAttribute('href') || '',
        nav_tier: isTier1 ? 1 : 2,
        nav_handle: handleEl ? handleEl.getAttribute('data-meganav-handle') : '',
        nav_device: isMobile() ? 'mobile' : 'desktop',
        nav_element_type: trackEl ? trackEl.getAttribute('data-mn-track') : (isTier1 ? 'tier1' : 'tier2'),
        nav_layout: layoutEl ? layoutEl.getAttribute('data-mn-layout') : 'dropdown',
        nav_panel_handle: panelEl ? (panelEl.getAttribute('data-meganav-handle') || panelEl.getAttribute('data-mn-panel-target') || panelEl.getAttribute('data-mn-tier1') || '') : '',
        nav_position: navPos
      });
      return;
    }

    // 2) Build-a-Gift-Set promo CTA — the funnel into the builder
    var promo = t.closest('.gsbp__btn');
    if (promo) {
      var section = promo.closest('.gsbp--a, .gsbp--b, .gsbp--c');
      var variant = '';
      if (section) {
        variant = section.classList.contains('gsbp--a') ? 'band'
          : section.classList.contains('gsbp--b') ? 'card' : 'strip';
      }
      track('gift_set_promo_click', {
        cta_text: txt(promo),
        promo_variant: variant,
        page_type: templateName()
      });
      return;
    }

    // 3) Gift-builder interactions (the AOV engine)
    var add = t.closest('[data-gsb-add]');
    if (add) {
      var card = add.closest('[data-gsb-id]');
      track('gift_builder_add', {
        product_id: card ? card.getAttribute('data-gsb-id') : '',
        product_handle: card ? card.getAttribute('data-gsb-handle') : ''
      });
      return;
    }
    var occ = t.closest('[data-gsb-occasion]');
    if (occ) { track('gift_builder_filter', { filter_type: 'occasion', filter_value: txt(occ) }); return; }
    var mood = t.closest('[data-gsb-mood]');
    if (mood) { track('gift_builder_filter', { filter_type: 'mood', filter_value: txt(mood) }); return; }
    var chip = t.closest('[data-gsb-chip]');
    if (chip) { track('gift_builder_filter', { filter_type: 'type', filter_value: txt(chip) }); return; }
    var rev = t.closest('[data-gsb-review], [data-gsb-review-mobile]');
    if (rev) { track('gift_builder_cta', { cta: 'add_note' }); return; }
    var addcart = t.closest('[data-gsb-addcart]');
    if (addcart) { track('gift_builder_cta', { cta: 'add_box_to_cart' }); return; }
  }, true);

  // 5) Blog click attribution — TWO events (2026-09-28, blog program rework Phase 0.2).
  //   blog_product_click — an article link to a /products/ or /collections/ page
  //                        (the GA4 key event; the dashboard's BlogCtaDaily source).
  //   blog_article_click — an article link to another /blogs/<blog>/<article>
  //                        (continue-reading + inline article links). Kept OUT of
  //                        blog_product_click so continue-reading never inflates
  //                        product CTAs or the key-event count.
  // Both carry the same params (blog_handle, cta_id, placement, link_type,
  // product_handle = the destination handle) so the registered GA4 dims apply.
  // Putting utm_ on an internal link is an ANTI-PATTERN (it overwrites the GA4
  // session source) — a click event is the instrument. cta_id + placement +
  // link_type vocab: ~/.claude/skills/monsuri-blog/references/cta-taxonomy.md
  // (must stay identical across the theme, the skill and the dashboard).
  //
  // Coverage:
  //   - v2 (article.monsuri): .art-body + the theme-rendered Journal surfaces
  //     (rail, mobile CTA, answer box, shop-the-ritual, featured, continue).
  //   - legacy (article.json / article.blog-template-2 / 'shogun'-suffix articles,
  //     which fall back to article.json — no article.shogun template exists):
  //     the body is .article_content; unstamped links get the fallback ids
  //     legacy-inline-body / legacy-featured-product (no per-article edits).
  // Links are matched relative (/products/x), absolute (https://monsuri.com/…,
  // https://www.monsuri.com/…, the myshopify domain), locale-prefixed (/fr/…) and
  // /collections/<c>/products/<p>; the destination is normalised to a path.
  // Only anchors INSIDE an article scope count — header/nav, cart drawer and
  // footer links on an article page are not blog clicks (and the nav already
  // fires mega_nav_click). One listener, one event per click.
  // See Documentation/GA4_MEASUREMENT_PLAN.md + Documentation/BLOG_AUTHORING.md.
  (function () {
    // Article page = the v2 body or the legacy body is on the page.
    if (!document.querySelector('.art-body, .blog-article__main .article_content')) return;
    if (window.__mdsBlogClickBound) return; // asset included twice → never bind twice
    window.__mdsBlogClickBound = true;

    // Where a tracked blog click can come from. Anything outside is ignored.
    var ARTICLE_SCOPE = '.art-body, .rail, .mobile-cta, .m-answer-box, .m-article-shop-ritual, ' +
      '.m-featured-product-section, .m-continue-section, .blog-article__main .article_content, [data-cta-id]';
    // Surfaces another handler in this file owns — never double-fire on them.
    var OWNED_ELSEWHERE = '.main-nav, .nav-mobile, .nav-desktop, [data-meganav-desktop], [data-meganav-mobile], ' +
      '.gsbp__btn, [data-gsb-id], .mds-pdp-xsell, .mds-pdp-reading';
    var LOCALE_SEG = /^[a-z]{2}(-[a-z0-9]{2,4})?$/i;

    function ownHosts() {
      var hosts = { 'monsuri.com': 1, 'www.monsuri.com': 1, 'monsuri.myshopify.com': 1 };
      hosts[window.location.hostname.toLowerCase()] = 1; // preview / localized domain
      if (window.Shopify && typeof window.Shopify.shop === 'string') hosts[window.Shopify.shop.toLowerCase()] = 1;
      return hosts;
    }
    var OWN_HOSTS = ownHosts();

    // href → { type: 'product'|'collection'|'blog', handle } or null.
    // Query string + hash are dropped; a link to another domain is null.
    function classifyHref(raw) {
      if (!raw || raw.charAt(0) === '#') return null; // same-page anchor (TOC)
      var url;
      try { url = new URL(raw, window.location.href); } catch (_e) { return null; }
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      if (!OWN_HOSTS[url.hostname.toLowerCase()]) return null;
      var seg = url.pathname.split('/').filter(Boolean);
      if (seg.length > 1 && LOCALE_SEG.test(seg[0]) && /^(products|collections|blogs)$/.test(seg[1])) seg = seg.slice(1);
      if (seg[0] === 'products' && seg[1]) return { type: 'product', handle: seg[1] };
      if (seg[0] === 'collections' && seg[2] === 'products' && seg[3]) return { type: 'product', handle: seg[3] };
      if (seg[0] === 'collections' && seg[1]) return { type: 'collection', handle: seg[1] };
      if (seg[0] === 'blogs' && seg[2] && seg[2] !== 'tagged') return { type: 'blog', handle: seg[2] };
      return null;
    }

    // Fallback cta_id + placement derived from the nearest known section wrapper —
    // used when no explicit data-cta-id is stamped (old articles, or a theme edit
    // that drops the attribute). Degrades to a section-level id, never to null.
    function deriveFromSection(el) {
      var node = el;
      while (node && node !== document.body) {
        if (node.classList) {
          if (node.classList.contains('rail')) return { ctaId: 'rail', placement: 'rail' };
          if (node.classList.contains('mobile-cta')) return { ctaId: 'mobile-cta', placement: 'rail' };
          if (node.classList.contains('m-answer-box')) return { ctaId: 'answer-box', placement: 'above_fold' };
          if (node.classList.contains('m-article-shop-ritual')) return { ctaId: 'bundle', placement: 'bundle' };
          if (node.classList.contains('m-featured-product-section')) return { ctaId: 'featured-section', placement: 'body' };
          if (node.classList.contains('m-continue-section')) {
            if (el.closest && el.closest('.continue-article')) return { ctaId: 'continue-article', placement: 'footer' };
            return { ctaId: 'continue-product', placement: 'footer' };
          }
          if (node.classList.contains('art-body')) return { ctaId: 'inline-body', placement: 'body' };
          if (node.classList.contains('custom-featured-collection')) return { ctaId: 'legacy-featured-product', placement: 'body' };
          if (node.classList.contains('article_content')) return { ctaId: 'legacy-inline-body', placement: 'body' };
        }
        node = node.parentNode;
      }
      return { ctaId: 'inline-body', placement: 'body' };
    }

    // Resolve cta_id + placement: explicit on the anchor → nearest [data-cta-id]
    // ancestor (the section wrapper) → deterministic section derivation.
    function resolveCta(anchor) {
      var explicit = anchor.getAttribute('data-cta-id');
      if (explicit) {
        return { ctaId: explicit, placement: anchor.getAttribute('data-placement') || deriveFromSection(anchor).placement };
      }
      var marked = anchor.closest ? anchor.closest('[data-cta-id]') : null;
      if (marked) {
        return { ctaId: marked.getAttribute('data-cta-id'), placement: marked.getAttribute('data-placement') || deriveFromSection(anchor).placement };
      }
      return deriveFromSection(anchor);
    }

    // Bot/QA guard (2026-08-16). On 2026-08-05 a scripted pass produced 85
    // blog_product_click events on one article (~3.5 real sessions/day) and
    // poisoned the dashboard's CTA tables. Three cheap guards at the source:
    //   - e.isTrusted: synthetic .click() / dispatchEvent never tracks
    //   - per-(cta_id, destination) session dedupe: a human re-clicking the
    //     same surface is one intent, not N events
    //   - a per-session cap (15): no genuine reader fires more; a crawler
    //     clicking every link goes silent after the cap
    // sessionStorage failures (private mode) fail-open to tracking untouched.
    // Dedupe + cap are PER ARTICLE (keyed by blog_handle): common cta_ids
    // (inline-body, bundle, continue-*) repeat across articles, so a
    // tab-session-wide key would silence legitimate clicks on the SECOND
    // article a reader visits. 15 events per article is far above any real
    // reading session; a crawler clicking everything goes quiet per page.
    // And PER EVENT: product clicks keep the original bucket (blog_handle);
    // article clicks use '<blog_handle>#article', so continue-reading can
    // never use up the product-click cap.
    var CLICK_SESSION_CAP = 15;
    function clickGuardAllows(bucket, ctaId, destHandle) {
      try {
        var raw = sessionStorage.getItem('mds_bpc') || '{}';
        var all = JSON.parse(raw);
        var state = all[bucket] || { n: 0, k: {} };
        var key = ctaId + '|' + destHandle;
        if (state.k[key]) return false; // duplicate surface on this article this session
        if (state.n >= CLICK_SESSION_CAP) return false; // per-article cap reached
        state.k[key] = 1;
        state.n += 1;
        all[bucket] = state;
        sessionStorage.setItem('mds_bpc', JSON.stringify(all));
        return true;
      } catch (_e) {
        return true; // storage unavailable → never block real tracking
      }
    }

    document.addEventListener('click', function (e) {
      if (e.isTrusted === false) return; // synthetic click — bot/QA, never track
      var t = e.target;
      if (!t || !t.closest) return;
      var anchor = t.closest('a[href]');
      if (!anchor || !anchor.closest(ARTICLE_SCOPE) || anchor.closest(OWNED_ELSEWHERE)) return;
      var dest = classifyHref(anchor.getAttribute('href'));
      if (!dest) return;
      var blogHandle = window.location.pathname.split('/').filter(Boolean).pop() || '';
      var isArticle = dest.type === 'blog';
      if (isArticle && dest.handle === blogHandle) return; // link to itself
      var cta = resolveCta(anchor);
      var bucket = isArticle ? blogHandle + '#article' : blogHandle;
      if (!clickGuardAllows(bucket, cta.ctaId || '', dest.handle)) return;
      track(isArticle ? 'blog_article_click' : 'blog_product_click', {
        blog_handle: blogHandle,
        cta_id: cta.ctaId || '',
        placement: cta.placement || '',
        link_type: dest.type,
        product_handle: dest.handle
      });
    }, true); // capture phase — fire before navigation/unload
  })();

  // 5b) Blog email capture (2026-10-12, blog dashboard replan Phase 0').
  // Two events per article page, both carrying blog_handle so the dashboard can
  // compute signups per 100 sessions and the exposure denominator:
  //   blog_email_form_view — a capture block entered the viewport (once per
  //                          article per tab-session)
  //   blog_email_signup    — Klaviyo's own `klaviyoForms` submit event, or the
  //                          Shopify customer-form fallback on submit-intent
  // Never sends the address (PII): form_id + placement only. In the same submit
  // handler the Klaviyo browser profile is tagged signup_source=blog:<handle> so
  // the Klaviyo side can attribute the subscriber (dashboard LeadCaptureEvent).
  (function () {
    var ARTICLE = '.m-article';
    if (!document.querySelector(ARTICLE)) return;
    var blogHandle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    if (!blogHandle) return;
    var CAPTURE_BLOCKS = '.rail-email-capture, .art-capture-mobile';

    function once(key) {
      try {
        var all = JSON.parse(sessionStorage.getItem('mds_bec') || '{}');
        if (all[key]) return false;
        all[key] = 1;
        sessionStorage.setItem('mds_bec', JSON.stringify(all));
        return true;
      } catch (_e) { return true; } // storage unavailable → never block real tracking
    }
    function placementOf(el) {
      var block = el && el.closest ? el.closest(CAPTURE_BLOCKS) : null;
      if (!block) return 'popup';
      return block.classList.contains('art-capture-mobile') ? 'below_body' : 'rail';
    }
    function fireSignup(formId, el) {
      if (!once('signup|' + blogHandle)) return;
      track('blog_email_signup', { blog_handle: blogHandle, form_id: formId || '', placement: placementOf(el) });
      try {
        var kl = window.klaviyo || window._learnq;
        if (!kl) { window._learnq = window._learnq || []; kl = window._learnq; }
        kl.push(['identify', { signup_source: 'blog:' + blogHandle }]);
      } catch (_e2) { /* Klaviyo optional */ }
    }

    // Exposure: the first capture block to enter the viewport (40% visible).
    if (window.IntersectionObserver) {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (seen || !entries[i].isIntersecting) continue;
          seen = true;
          if (once('view|' + blogHandle)) {
            track('blog_email_form_view', { blog_handle: blogHandle, placement: placementOf(entries[i].target) });
          }
          io.disconnect();
          break;
        }
      }, { threshold: 0.4 });
      var blocks = document.querySelectorAll(CAPTURE_BLOCKS);
      for (var j = 0; j < blocks.length; j++) io.observe(blocks[j]);
    }

    // Klaviyo onsite dispatches `klaviyoForms` on window for open / submit / close.
    // The same `klaviyo-form-<id>` mount exists twice on an article (desktop rail +
    // the mobile block), so the FIRST match is the hidden rail on phones — pick the
    // mount that is actually shown (or holds focus), else the event reads 'rail'.
    function shownMount(formId) {
      var mounts;
      try { mounts = document.querySelectorAll('.klaviyo-form-' + (window.CSS && CSS.escape ? CSS.escape(formId) : formId)); }
      catch (_e) { return null; }
      var first = null;
      for (var i = 0; i < mounts.length; i++) {
        var m = mounts[i];
        if (!first) first = m;
        if (document.activeElement && m.contains(document.activeElement)) return m;
        if (m.getClientRects().length > 0) return m;
      }
      return first;
    }
    window.addEventListener('klaviyoForms', function (e) {
      var d = e && e.detail;
      if (!d || d.type !== 'submit') return;
      var formId = d.formId || '';
      var mount = formId ? shownMount(formId) : null;
      // Only the ARTICLE's own capture blocks are blog captures. A site-wide popup
      // that happens to open on an article is the popup's conversion, not the
      // blog's — counting it would credit the article for a form it never rendered.
      if (!mount || !mount.closest(CAPTURE_BLOCKS)) return;
      fireSignup(formId, mount);
    });

    // Shopify customer-form fallback (renders until Klaviyo hydrates). The native
    // {% form 'customer' %} posts and redirects back to the article with
    // `?customer_posted=true` ONLY on success, so the signup is counted on that
    // landing — never on submit-intent (a rejected / challenged submit must not
    // count). Attribution for this path rides on the hidden `contact[tags]`
    // value (`blog-<handle>`) the form posts to Shopify, not on a Klaviyo identify
    // (which could not be tied to the address without sending it).
    try {
      var qs = window.location.search || '';
      if (/[?&]customer_posted=true(&|$)/.test(qs)) {
        var fallbackBlock = document.querySelector('.art-capture-mobile') || document.querySelector('.rail-email-capture');
        if (fallbackBlock && once('signup|' + blogHandle)) {
          track('blog_email_signup', { blog_handle: blogHandle, form_id: 'shopify_fallback', placement: placementOf(fallbackBlock) });
        }
      }
    } catch (_e3) { /* never break the page for analytics */ }
  })();

  // 5c) Blog scroll depth (2026-10-20, guide layout v2). GA4's built-in `scroll`
  // event fires once at 90% with no page dimension, so the dashboard could never
  // say how far readers of ONE article get. This fires blog_scroll_depth at
  // 25 / 50 / 75 / 90, once per threshold per article per tab-session, with the
  // article handle and the layout it was served under (standard | guide) so the
  // guide-v2 experiment can read "did the table get seen" per page. The scroll
  // listener is passive + rAF-throttled and unbinds itself after 90.
  (function () {
    var article = document.querySelector('.m-article');
    if (!article) return;
    var blogHandle = window.location.pathname.split('/').filter(Boolean).pop() || '';
    if (!blogHandle) return;
    var layout = article.getAttribute('data-layout') || 'standard';
    var THRESHOLDS = [25, 50, 75, 90];
    var pending = THRESHOLDS.slice();
    var ticking = false;

    function once(key) {
      try {
        var all = JSON.parse(sessionStorage.getItem('mds_bsd') || '{}');
        if (all[key]) return false;
        all[key] = 1;
        sessionStorage.setItem('mds_bsd', JSON.stringify(all));
        return true;
      } catch (_e) { return true; } // storage unavailable → never block real tracking
    }
    function measure() {
      ticking = false;
      var doc = document.documentElement;
      var total = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
      if (!total) return;
      var pct = ((window.pageYOffset || doc.scrollTop || 0) + window.innerHeight) / total * 100;
      while (pending.length && pct >= pending[0]) {
        var n = pending.shift();
        if (once('scroll' + n + '|' + blogHandle)) {
          track('blog_scroll_depth', { blog_handle: blogHandle, layout: layout, percent_scrolled: n });
        }
      }
      if (!pending.length) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      (window.requestAnimationFrame || window.setTimeout)(measure);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // A short article (or a tall viewport) can already sit past a threshold on load.
    onScroll();
  })();

  // 6) Corporate gifting — quote-request submit (KEY conversion for the B2B launch).
  // The native {% form 'contact' %} server-redirects, so fire on submit-intent, deduped.
  // Send ONLY banded/categorical fields — never name/email (PII). The honeypot +
  // native required-field validation gate most spam before this fires.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    if (!form.closest('[data-corp-form]')) return;
    if (form.getAttribute('data-ga-quote-fired')) return;
    form.setAttribute('data-ga-quote-fired', '1');
    var setsEl = form.querySelector('#corp-sets, [name="contact[Sets]"]');
    var occEl = form.querySelector('#corp-occasion, [name="contact[Occasion]"]');
    var sets = setsEl ? parseInt(setsEl.value, 10) : 0;
    var setsBand = !sets ? 'unknown' : sets < 25 ? '1-24' : sets < 100 ? '25-99' : sets < 250 ? '100-249' : '250plus';
    track('corp_bundle_quote_request', {
      corp_occasion: occEl ? (occEl.value || '') : '',
      sets_band: setsBand,
      page_type: templateName()
    });
  }, true);

  // 7) PDP interaction events — internal-linking + cross-sell engagement signals for the
  // CVR / AOV / UPT story. Elevar owns view_item / add_to_cart / purchase; these capture the
  // on-page clicks that the redesign adds. Matches the existing .mds-pdp-* classes (no snippet
  // changes); each fires at most one branch.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest('a');
    if (t.closest('.mds-pdp-xsell') && a) { track('pdp_cross_sell_click', { link_href: a.getAttribute('href') || '', page_type: templateName() }); return; }
    if (t.closest('.mds-pdp-reading') && a) { track('pdp_journal_click', { link_href: a.getAttribute('href') || '', page_type: templateName() }); return; }
    var chip = t.closest('a.mds-pdp-chip');
    if (chip) { track('pdp_scent_family_click', { link_href: chip.getAttribute('href') || '', page_type: templateName() }); }
  }, true);
})();
